<template>
  <div class="unlockable-plan-button">
    <button
      class="action-button"
      depressed
      large
      @click.prevent="unlock"
    >
      <div class="left-side-icon">
        <i class="fas fa-2xl" :class="{ 'fa-lock': !unlocked, 'fa-unlock': unlocked }" />
      </div>
      <div class="content" :class="{ unlocked }">
        <div class="plan-title">
          Plano {{ plan.title }}
        </div>
        <div class="plan-price">
          R$ {{ price }}
        </div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'UnlockablePlanButton',
  props: {
    plan: { type: Object, required: true },
    locked: { type: Boolean, required: false, default: false },
    onClick: { type: Function, required: false, default: () => {} }
  },
  data: () => ({ unlocked: false }),
  computed: {
    price() {
      let price = (this.plan.value - this.plan.discount) / 100
      if (this.plan.discount_type === 'percentage') {
        price =
          (this.plan?.value - (this.plan?.value * this.plan?.discount) / 100) /
            100 || ''
      }

      return Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price)
    }
  },
  mounted() {
    this.unlocked = !this.locked
  },
  methods: {
    unlock() {
      if (this.unlocked) {
        this.onClick && this.onClick()
      } else {
        this.unlocked = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.unlockable-plan-button {
  display: flex;
  justify-content: center;
  width: 100%;

  .action-button {
    height: 80px;
    border-radius: 8px;
    padding: 16px 24px;
    background-color: $neutral200;
    display: flex;
    align-items: center;

    & > :not(:first-child) {
      margin-left: 16px;
    }

    .content {
      text-align: left;
      color: $neutral500;
      filter: blur(5px);

      &.unlocked {
        filter: none;
      }

      & > :not(:last-child) {
        margin-bottom: 4px;
      }

      .plan-title {
        @include LabelSmall;
        font-family: $monserratFontFamily;
        font-weight: 700;
      }

      .plan-price {
        @include HeadingXSmall;
        font-family: $monserratFontFamily;
      }
    }

    .left-side-icon {
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $neutral500;
    }
  }
}
</style>
